import React from "react";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

const ProClientAllergyDetails = ({formModel})=>{
    return <div>
         <DataTable value={formModel}>
            <Column field="dateOfOnSet" header="Date of Onset"></Column>
            <Column field="allergen" header="Allergen"></Column>
            <Column field="allergenRxNormCode" header="Allergen Rxnorm Code"></Column>
            <Column field="ndcId" header="NDC ID"></Column>
            <Column field="reaction" header="Reaction"></Column>
            <Column field="reactionSnomedCode" header="Reaction SNOMED Code"></Column>              
        </DataTable>
    </div>

}

export default ProClientAllergyDetails;